export const TRX_PRECISION = 6
export const RCC_PRECISION = 6

export const RCC_ADDRESS = process.env.REACT_APP_RCC_ADDRESS || ''

export const MAX_FEE_LIMIT = 10_000_000_000
